export default __webpack_public_path__ + "static/media/bg1.ff470a2d.jpeg";